export function getView(contact_method_associations) {
  return contact_method_associations.some(cma => !!cma.contact_method.email)
}
